import _ from 'lodash';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import { getDateFormat } from '../../utils/suitableDate';
import { API_GET_DRIVER_BILLINGS } from '../../constants/apisPath';
import { getIdToken } from '../../apis/firebase';
import { sendGetRequest } from '../../utils/apiService';
import { ORDER_COMPLETED, ORDER_SUCCESS } from '../../constants';
import store from '../../utils/store';
import { getCompletedOrders } from '../../apis/backend';
import { DriverBilling } from 'src/models/drivers/driverBilling';
import React, { ReactElement } from 'react';
import { ExtendedDriverData } from 'src/models/drivers/driver';
import { DriverModalState } from './DriverModal';

type RenderDriverInvoiceFunction = (selectedBilling: DriverBilling) => ReactElement

const download = (zip: JSZip, driver: ExtendedDriverData) => {
  const { firstName, lastName } = driver;
  zip.generateAsync({ type: 'blob' }).then(function(blob) {
    saveAs(blob, `${firstName}${lastName}.zip`);
  });
};

export const generateZip = (charges: string[], driver: ExtendedDriverData, billings: DriverBilling[], renderDriverInvoice: RenderDriverInvoiceFunction) => {
  const zip = JSZip();  
  for (const chargeId of charges) {
    const billingItem: DriverBilling = _.find(billings, (bill: DriverBilling) => bill.chargeId === chargeId);
    if (billingItem) {
      const { dateOrder, orderNumber } = billingItem;
      zip.file(
        `factures/${getDateFormat(dateOrder, 'DDMMYYYY')}${orderNumber}.pdf`,
        pdf(renderDriverInvoice(billingItem)).toBlob()
      );
    }
  }
  download(zip, driver);
};

export const handleSelectAllClick = (
  event: React.ChangeEvent<HTMLInputElement>, 
  rows: DriverBilling[], 
  setComponentState: React.Dispatch<React.SetStateAction<DriverModalState>>) => {
  if (event.target.checked) {
    const newSelection = _.map(rows, (bill: DriverBilling) => bill.chargeId);
    setComponentState(prevState => ({ ...prevState, selected: newSelection }));
  } else setComponentState(prevState => ({ ...prevState, selected: [] }));
};

export const handleClick = (chargeId: string, selected: string[], setComponentState: React.Dispatch<React.SetStateAction<DriverModalState>>) => {
  const selectedIndex = selected.indexOf(chargeId);
  let newSelected: string[] = [];
  if (selectedIndex === -1) {
    newSelected = newSelected.concat(selected, chargeId);
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(selected.slice(1));
  } else if (selectedIndex === selected.length - 1) {
    newSelected = newSelected.concat(selected.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      selected.slice(0, selectedIndex),
      selected.slice(selectedIndex + 1)
    );
  }
  setComponentState(prevState => ({ ...prevState, selected: newSelected }));
};

export const getDriverBillingsByShopId = async (driverId: string) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
    const response = await sendGetRequest(
      `${API_GET_DRIVER_BILLINGS}/${driverId}`
      , { shopId },
      { Authorization: `Bearer ${idToken}` }
    );
    return response.data
  
};

export const getDataValue = (value: string) => { return value || '--' };

export const initDriverData = async (
  driver: ExtendedDriverData, 
  shopId: string, 
  isIndependentTab: boolean, 
  setDriverState: React.Dispatch<React.SetStateAction<ExtendedDriverData | null>>, 
  setBillings: React.Dispatch<React.SetStateAction<DriverBilling[]>>, 
  setComponentState: React.Dispatch<React.SetStateAction<DriverModalState>>) => {

  let fees = 0;
  let canceledOrders = 0;
  const driverBillings = isIndependentTab ? await getDriverBillingsByShopId(driver.id) : await getCompletedOrders(shopId, 'idDep', driver.id);
  _.map(driverBillings, (billing: DriverBilling) => {
    if (billing.shopId === shopId) {
    //   const { priceOrder: valueGenerated } = billing;
      const isSuccessOrder = (billing.status === ORDER_SUCCESS || billing.status === ORDER_COMPLETED) && billing.orderNumber
      if (isSuccessOrder) {
        if (driver?.duration >= 0) driver.duration += parseFloat(String(billing.delivery.duration));
        if (driver?.distance >= 0) driver.distance += parseFloat(String(billing.delivery.distance));
        fees += parseFloat(String(billing.delivery.fee));
      }
      //   if (valueGenerated) {
      //     driver.valueGenerated += valueGenerated ? parseFloat(String(valueGenerated)) : 0;
      //   }
      if (billing.cancellation && billing.status === 'canceled') {
        canceledOrders++;
        driver.cancelNb = canceledOrders;
      }
    }
  });
  setDriverState({
    ...driver,
    fee: Math.round(fees * 100) / 100,
    // valueGenerated: Math.round(driver.valueGenerated * 100) / 100,
    speed: driver.duration > 0 ? 
      Math.round((driver.distance / driver.duration) * 6000) / 100
      : 0,
    durationPerOrder: Math.round((driver.duration / driver.nbOrderSuccess) * 100) / 100 || 0,
    distancePerOrder: Math.round((driver.distance / driver.nbOrderSuccess) * 100) / 100 || 0, })
  setBillings(
    _.orderBy(
      _.filter(
        driverBillings,
        (bill: DriverBilling) => bill.orderNumber && bill.status === ORDER_SUCCESS
      ),
      ['dateOrder', 'orderNumber'],
      ['desc', 'desc']
    ))
  setComponentState(prevState => ({ ...prevState, isLoading: true }))
};